import { useMsal } from "@azure/msal-react";
import { getTokensRaw } from "../config/authConfig";
import { useCallback } from "react";

const REACT_APP_API_URL =
  "https://mitarbeiterportal-backend-abc8bubxdpddg3du.westeurope-01.azurewebsites.net/";

async function getCards(instance, inProgress) {
  const idAndAccessToken = await getTokensRaw(instance, inProgress);

  const response = await fetch(REACT_APP_API_URL + "/api/cards", {
    method: "GET",
    credentials: "include",
    headers: {
      Authorization: "Bearer " + idAndAccessToken.idToken,
      "X-BTB-Access-Token": idAndAccessToken.accessToken,
      "Content-Type": "application/json",
    },
  });
  if (!response.ok) {
    console.error("Die Anwendungskarten können nicht geladen werden.");
    return { list: [] };
  }

  const cards = await response.json();
  return cards;
}

async function saveCards(cards, instance, inProgress) {
  const idAndAccessToken = await getTokensRaw(instance, inProgress);
  const json = JSON.stringify({ list: cards });

  const response = await fetch(REACT_APP_API_URL + "/api/cards", {
    method: "PUT",
    credentials: "include",
    headers: {
      Authorization: "Bearer " + idAndAccessToken.idToken,
      "X-BTB-Access-Token": idAndAccessToken.accessToken,
      "Content-Type": "application/json",
    },
    body: json,
  }).catch((error) => {
    console.error("Die Anwendungskarten können nicht hochgeladen werden. ");
    console.error(error);
    return { list: [] };
  });
  if (!response.ok) {
    console.error("Die Anwendungskarten können nicht hochgeladen werden.");
    return { list: [] };
  }

  const updatedCards = await response.json();
  return updatedCards;
}

async function getAccountInfo(instance, inProgress) {
  const idAndAccessToken = await getTokensRaw(instance, inProgress);
  const response = await fetch("https://graph.microsoft.com/v1.0/me", {
    method: "GET",
    headers: {
      Authorization: `Bearer ${idAndAccessToken.accessToken}`,
    },
  });
  const responseData = await response.json();

  return responseData;
}

export default function useFetching() {
  const { instance, inProgress } = useMsal();
  const getCardsCallback = useCallback(
    function () {
      return getCards(instance, inProgress);
    },
    [instance, inProgress]
  );

  const saveCardsCallback = useCallback(
    function (cards) {
      return saveCards(cards, instance, inProgress);
    },
    [instance, inProgress]
  );

  const getAccountInfoCallback = useCallback(
    function () {
      return getAccountInfo(instance, inProgress);
    },
    [instance, inProgress]
  );

  return {
    getCards: getCardsCallback,
    saveCards: saveCardsCallback,
    getAccountInfo: getAccountInfoCallback,
  };
}
